module.exports = __webpack_public_path__ + "img/home1.aafb883a.jpg";